import React, { useState } from "react";
import axios from "axios";

function AddSeasonModal({ leagueId, onSeasonAdded }) {
    const [name, setName] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [banner, setBanner] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append("league", leagueId);
        formData.append("name", name);
        formData.append("start_date", startDate);
        formData.append("end_date", endDate);
        if (banner) formData.append("banner", banner);

        axios
            .post("/api/leagues/add-season/", formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
            })
            .then((response) => {
                onSeasonAdded(response.data.season);
                setName("");
                setStartDate("");
                setEndDate("");
                setBanner(null);
                document.getElementById("closeAddSeasonModal").click(); // Close modal
            })
            .catch((err) => {
                console.error("Error adding season:", err);
                setError("Failed to add season. Please try again.");
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="modal fade" id="addSeasonModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add New Season</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="seasonName" className="form-label">Season Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="seasonName"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="startDate" className="form-label">Start Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="startDate"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="endDate" className="form-label">End Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="endDate"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="banner" className="form-label">Banner</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="banner"
                                    onChange={(e) => setBanner(e.target.files[0])}
                                />
                            </div>
                            {error && <div className="text-danger mb-3">{error}</div>}
                            <div className="d-flex justify-content-end">
                                <button
                                    type="button"
                                    className="btn btn-secondary me-2"
                                    data-bs-dismiss="modal"
                                    id="closeAddSeasonModal"
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? "Adding..." : "Add Season"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddSeasonModal;